import localStorage from './localStorage';

export default (key) => {
	const basicInfo = localStorage.read('basic_info');
	if (typeof basicInfo !== 'string') { return {}; }
	if (key === 'contentServer' && process.env.NODE_ENV !== 'development') {
		const str = JSON.parse(basicInfo)[key];
		if (typeof str !== 'string') { return {}; }
		return window.location.protocol + str.split(':')[1];
	}
	return JSON.parse(basicInfo)[key];
};

// 获取基础参数
export const getBaseParams = (communityId) => {
	const { namespaceId, moduleId, organizationId, instanceConfig } = window.$$context;
	const { categoryId } = JSON.parse(instanceConfig || '{}');
	const baseParams = {
		namespaceId,
		categoryId,
		ownerType: communityId === '-1' ? 'organization' : 'community',
		ownerId: communityId === '-1' ? organizationId : communityId,
		organizationId,
		orgId: organizationId,
		moduleId,
		communityId
	};

	return baseParams;
};

export const getBaseParamsWithOwnerType = (data) => {
	const { communityId, organizationId } = data
	return {
		...data,
		ownerType: communityId === '-1' ? 'organization' : 'community',
		ownerId: communityId === '-1' ? organizationId : communityId,
		orgId: organizationId
	}
}
